import React from "react";
import { StylesConfig } from "react-select";
import ReactSelectCreatable from "react-select/creatable";

export type StringOption = {
  label: string;
  value: string;
  __isNew__?: boolean;
};

export type OptionGroup<T> = {
  label: string;
  options: T[];
};
type OptionsOrGroups<T> = T[] | OptionGroup<T>[];

type Props<T> = {
  value: T | null;
  options: OptionsOrGroups<T>;
  onChange: (selected: T | null) => void;
  placeholder?: React.ReactNode;
  isClearable?: boolean;
  isDisabled?: boolean;
  onFocus?: (event: any) => void;
  onBlur?: (event: any) => void;
  ariaLabel?: string;
};

type MultiProps<T> = {
  value: T[] | null;
  options: OptionsOrGroups<T>;
  onChange: (selected: T[] | null) => void;
  placeholder?: React.ReactNode;
  isClearable?: boolean;
  isDisabled?: boolean;
  onFocus?: (event: any) => void;
  onBlur?: (event: any) => void;
  ariaLabel?: string;
};

export const reactSelectStyles: StylesConfig = {
  control: (base, state) => ({
    ...base,
    border: state.isFocused ? "1px solid #66afe9" : "1px solid #ccc",
    boxShadow: state.isFocused
      ? "0 2px 3px 0 rgba(34, 36, 38, 0.15)"
      : base.boxShadow,
    "&:hover": {
      border: "1px solid #66afe9",
      boxShadow: "0 2px 3px 0 rgba(34, 36, 38, 0.15)",
    },
    "&:focus": {
      border: "1px solid #66afe9",
      boxShadow: "0 2px 3px 0 rgba(34, 36, 38, 0.15)",
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#337ab7"
      : state.isFocused
      ? "#e6f3fb"
      : base.backgroundColor,
  }),
};

function CreatableSelect<T>({
  value,
  options,
  onChange,
  placeholder,
  isClearable,
  isDisabled,
  onFocus,
  onBlur,
  ariaLabel,
}: Props<T>): React.ReactElement {
  return (
    <ReactSelectCreatable
      value={value}
      options={options}
      onChange={onChange}
      isClearable={isClearable}
      placeholder={placeholder}
      isDisabled={isDisabled}
      onFocus={onFocus}
      onBlur={onBlur}
      styles={reactSelectStyles}
      aria-label={ariaLabel}
    />
  );
}

export function CreatableMultiSelect<T>({
  value,
  options,
  onChange,
  placeholder,
  isClearable,
  isDisabled,
  onFocus,
  onBlur,
  ariaLabel,
}: MultiProps<T>): React.ReactElement {
  return (
    <ReactSelectCreatable
      value={value}
      options={options}
      onChange={onChange}
      isClearable={isClearable}
      placeholder={placeholder}
      isDisabled={isDisabled}
      onFocus={onFocus}
      onBlur={onBlur}
      styles={reactSelectStyles}
      isMulti
      aria-label={ariaLabel}
    />
  );
}

export default CreatableSelect;
